﻿/**
 * RGD Common Files
 *
 * Log Helper
 *
 * Use to make logs to NLog
 *
 */
window["rgdCommonLogHelper"] = (function ($) {

    /*
     * Private 
     */

    //#region Private Properties and Variables

    var previousCheck;

    var stacktraceFromException = function(exception) {
        return exception.stack || exception.backtrace || exception.stacktrace;
    }

    //#endregion

    //#region Private Methods

    /**
     * NLog Errors
     * Asynchronously Log JavaScript errors to the error controller service (inline)
     * This will log to whatever, is connfigured for NLog
     * e.g. at the time of ceration (26/01/2018):
     *  - NLog
     *  - Elmah
     * 
     *
     * @param {any} errorText
     * @param {any} url
     * @param {any} lineNumber
     * @param {any} col
     * @param {any} exception
     */
    var logErrorAsync = function (errorText, url, lineNumber, col, exception) {

        var jsonData = {
            errorText: errorText || '',
            url: url || '',
            lineNumber: lineNumber || 0,
            column: col || (window.event && window.event.errorCharacter) || 0,
            errorStack: (exception && stacktraceFromException(exception)) || 'Unable to generate stacktrace'
        };

        // prevent duplicates if client goes into an infinite loop
        var duplicateCheck = [errorText, url].join('|');
        if (duplicateCheck === previousCheck) { return; }
        previousCheck = duplicateCheck;

        try {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/errorjs/record', true);
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.setRequestHeader('X-Error', true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onreadystatechange = function () {
                if (xhr.readyState !== 4 || xhr.status !== 200) return;
            };
            xhr.send(JSON.stringify(jsonData));
        }
        catch (ex) {
            // just catch
        }
    }

    /**
     * NLog Trace
     * @param {any} message
     */
    var logTraceAsync = function (message) {

        var jsonData = {
            message: message
        }

        try {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/errorjs/trace', true);
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.setRequestHeader('X-Error', true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onreadystatechange = function () {
                if (xhr.readyState !== 4 || xhr.status !== 200) return;
            };
            xhr.send(JSON.stringify(jsonData));
        }
        catch (ex) {
            // just catch
        }

	}

	var logWarningAsync = function (errorText, url, lineNumber, col, exception) {
		
		var report = {
			errorText: errorText || '',
			url: url || '',
			lineNumber: lineNumber || 0,
			column: col || (window.event && window.event.errorCharacter) || 0,
			errorStack: (exception && stacktraceFromException(exception)) || 'Unable to generate stacktrace'
		};

		// prevent duplicates if client goes into an infinite loop
		var duplicateCheck = [errorText, url].join("|");
		if (duplicateCheck === previousCheck) { return; }
		previousCheck = duplicateCheck;

		try {
			var xhr = new XMLHttpRequest();
			xhr.open("POST", "/errorjs/warning", true);
			xhr.setRequestHeader("Content-type", "application/json");
			xhr.setRequestHeader("X-Error", true);
			xhr.onreadystatechange = function () {
				if (xhr.readyState != 4 || xhr.status != 200) return;
			};
			xhr.send(JSON.stringify(report));
		}
		catch (ex) {
			// just catch
		}
	}

    //#endregion

    /*
     * Public Methods and Properties
     */
    return {
      NLogErrorAsync: logErrorAsync,
		NLogTraceAsync: logTraceAsync,
		NLogWarningAsync: logWarningAsync
    }

})(jQuery);